const ItemCategory = {

    // FIELDS
    "item_category": "Item Category",
    "name": "Name",
    "description": "Description",
    "status": "Status",
    "search": "Search",
    
    // PAGE HEADER
    "list_title": "Item Category",
    "filter_title": "Item Category Filter",
    
    // TABLE HEADER
    "table_name": "Name",
    "table_description": "Description",
    
    // ERROR
    "error_name": "Enter Item Category Name",
    "error_description": "Enter Description",
    "error_status": "Select Status",

}

export default ItemCategory;

